"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberSliderFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const google_sheet_1 = require("../../utils/google-sheet");
const migration_1 = require("../../utils/migration");
const detailed_decimal_1 = require("../../formatters/detailed-decimal");
const number_slider_fieldtype_1 = require("../../safe-field-value/numder-fields/number-slider-field/number-slider.fieldtype");
const validation_1 = require("../../validation/validation");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
const texts_1 = require("../../texts");
const intl_1 = require("../../locale/intl");
const number_1 = require("../../utils/number");
var NumberSliderDisplayFormat;
(function (NumberSliderDisplayFormat) {
    NumberSliderDisplayFormat["small"] = "small";
    NumberSliderDisplayFormat["medium"] = "medium";
    NumberSliderDisplayFormat["large"] = "large";
})(NumberSliderDisplayFormat || (NumberSliderDisplayFormat = {}));
class NumberSliderFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "numbersliderfield";
        this.label = (0, intl_1.$t)(texts_1.numberSliderFieldText.number_slider);
        this.icon = "number-slider";
        this.iconColor = "#EC506E";
        this.placeholder = (0, intl_1.$t)(texts_1.numberSliderFieldText.enter_number_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.numberSliderFieldText.progress),
            (0, intl_1.$t)(texts_1.numberSliderFieldText.done),
        ];
        this.isNumber = true;
        this.groupByMode = "card";
        this.fieldValueGetter = new number_slider_fieldtype_1.NumberSliderFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            autonumberfield: clipboard_1.clipboardTextToSlider,
            countfield: clipboard_1.clipboardTextToSlider,
            currencyfield: clipboard_1.clipboardTextToSlider,
            numberfield: clipboard_1.clipboardTextToSlider,
            numbersliderfield: clipboard_1.clipboardTextToSlider,
            percentcompletefield: clipboard_1.clipboardTextToSlider,
            percentfield: clipboard_1.clipboardTextToSlider,
            ratingfield: clipboard_1.clipboardTextToSlider,
            rollupfield: clipboard_1.clipboardTextToSlider,
            textfield: clipboard_1.clipboardTextToSlider,
            recordtitlefield: clipboard_1.clipboardTextToSlider,
            votefield: clipboard_1.clipboardTextToSlider,
            unknownfield: clipboard_1.clipboardTextToSlider,
        };
    }
    get validators() {
        return { required: validation_1.required, integerNumberField: validation_1.integerNumberField, numberBetweenMinMaxValue: validation_1.numberBetweenMinMaxValue };
    }
    valueToString(fieldValue, _field, _userPreferences) {
        if (fieldValue === null || fieldValue === undefined) {
            return "";
        }
        return fieldValue.toString();
    }
    getAggregateDisplayValue(fieldValue, field, userPreferences) {
        var _a, _b;
        if (!fieldValue) {
            return "";
        }
        return (0, detailed_decimal_1.convertNumberToFormatedString)({
            value: fieldValue,
            precision: 1,
            decimalSeparator: (0, number_1.getDecimalSeparator)((_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value),
            thousandSeparator: (0, number_1.getGroupSeparator)((_b = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _b === void 0 ? void 0 : _b.value),
        });
    }
    valueToGoogleSheet(fieldValue) {
        return (0, google_sheet_1.makeRowDataValues)(fieldValue, "numberValue");
    }
    valueToExcelExport(fieldValue, field, userPreferences, _record) {
        const value = this.valueToExport(fieldValue, field, userPreferences, _record);
        return {
            t: value ? "n" : "t",
            v: value,
        };
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            enableCopyEventInEditMode: true,
            enablePasteEventInEditMode: true,
            deleteValueOnFirstKeypress: true,
        };
    }
    isValueEmpty(fieldValue) {
        return fieldValue === null || (!fieldValue && Number(fieldValue) !== 0);
    }
    isDefaultEmpty(field) {
        return this.isValueEmpty(field.params.default_value);
    }
    getInitialFieldValue(startValue, field, userPreferences) {
        return this.validateValue(field, startValue, true, userPreferences)
            ? startValue
            : this.getEmptyValue();
    }
    canChangeValue(field, fromValue, toValue) {
        const { params: { min_value: minValue, max_value: maxValue }, } = field;
        const isValidRange = this.isValueEmpty(toValue) ||
            (toValue >= (minValue !== null && minValue !== void 0 ? minValue : 0) && toValue <= (maxValue !== null && maxValue !== void 0 ? maxValue : 0));
        return isValidRange && super.canChangeValue(field, fromValue, toValue);
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 110,
            minWidth: 60,
        };
    }
    migrateField(fieldTo, fieldFrom) {
        var _a;
        const displayFormats = Object.values(NumberSliderDisplayFormat);
        const migratedField = super.migrateField(fieldTo, fieldFrom);
        return (0, migration_1.migrateDisplayFormat)(migratedField, displayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    getDefaultValue(field) {
        var _a;
        return +((_a = field.params.default_value) !== null && _a !== void 0 ? _a : 0) || 0;
    }
    filterToRecordValue(filterValue, comparison, field) {
        var _a, _b;
        if (comparison !== "is_equal_to" || !(0, number_1.isNumeric)(filterValue)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        const value = Number(filterValue);
        if (value < ((_a = field.params.min_value) !== null && _a !== void 0 ? _a : 0) ||
            value > ((_b = field.params.max_value) !== null && _b !== void 0 ? _b : 0)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        return value;
    }
}
exports.NumberSliderFieldLogic = NumberSliderFieldLogic;
